var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3346 15.668V16.3346C25.3346 16.7028 25.0362 17.0013 24.668 17.0013H17.0013V24.668C17.0013 25.0361 16.7028 25.3346 16.3346 25.3346H15.668C15.2998 25.3346 15.0013 25.0361 15.0013 24.668V17.0013H7.33464C6.96645 17.0013 6.66797 16.7028 6.66797 16.3346V15.668C6.66797 15.2998 6.96645 15.0013 7.33464 15.0013H15.0013V7.33463C15.0013 6.96644 15.2998 6.66797 15.668 6.66797H16.3346C16.7028 6.66797 17.0013 6.96644 17.0013 7.33463V15.0013H24.668C25.0362 15.0013 25.3346 15.2998 25.3346 15.668Z",
    fill: "url(#paint0_linear_2775_4942)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2775_4942",
    x1: 5.56494,
    y1: 5.81949,
    x2: 32.1225,
    y2: 29.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0237219,
    stopColor: "#FA96C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156443,
    stopColor: "#FF669B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904397,
    stopColor: "#BD8DE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.d224476216f34fa07346512d4afa66f2.svg";
export { ForwardRef as ReactComponent };